import type { LatLngTuple } from 'leaflet'

const BOUNDING_BOX = {
  COORDINATES: {
    southWest: [52.25168, 4.64034] as LatLngTuple,
    northEast: [52.50536, 5.10737] as LatLngTuple,
  },
}

export default BOUNDING_BOX
